// TVChannelSection.tsx
import { useEffect, useState, Suspense } from "react";
import { lazy } from "react";
import LiveTVService from "services/liveTv/LiveTVService";
import { convertFromGetAllChannels } from "utils/convertLiveTVData";
import ErrorBoundary from "components/error-fallbacks/ErrorFallBack";

// Lazy load the ChannelCoursel component
const ChannelCoursel = lazy(
  () => import("pages/liveTvPage/home/ChannelCoursel")
);

function TVChannelSection() {
  const [channels, setChannels] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchChannels = async () => {
      setIsLoading(true);
      try {
        const res = await LiveTVService.getFeaturedChannels();
        setIsLoading(false);

        if (res.data) {
          const convertedChannels = res.data
            .map((d: any) => convertFromGetAllChannels(d))
            .filter(
              (c: any, index: number, self: any[]) =>
                // Remove duplicates based on uuid
                index === self.findIndex((channel) => channel?.uuid === c?.uuid)
            );

          setChannels(convertedChannels);
        }
      } catch (error) {
        setIsLoading(false);
        console.error("Failed to fetch featured channels:", error);
        // Optionally set an error state here
      }
    };

    fetchChannels();
  }, []);

  return (
    <div className="mb-10">
      <ErrorBoundary>
        <Suspense>
          <ChannelCoursel data={channels} isLoading={isLoading} />
        </Suspense>
      </ErrorBoundary>
    </div>
  );
}

export default TVChannelSection;
